// Libs
import React, { ReactElement } from 'react';
// App
import { Typography, TypographyProps } from 'ui-components';

/**
 * Create a specific paper container for auth module (the backgroud is light but not white as content card)
 * Designed to be used a root of a page
 * @param param the component children
 */
const ContentCardTitle = (props: TypographyProps): ReactElement => {
  return <Typography variant="h1" align="center" {...props}></Typography>;
};

export default ContentCardTitle;
